import { CircleAlertIcon, CircleCheckIcon } from 'lucide-react';

import { Button } from '@/components/ui/button';

import { SIGN_IN_COPY } from '../copy';
import { outcomeWords, type LinkOutcome } from '../linkOutcome';

/**
 * What came of signing in on the forge (spec 161 US2), said at the top of the
 * panel the return lands on. Inline rather than a toast: the person has just
 * come back from another site, and a toast that fades while the page loads is
 * easily missed. Stays until dismissed or the page is left.
 */
export function LinkOutcomeMessage({
  outcome,
  forge,
  onDismiss,
}: {
  outcome: LinkOutcome;
  forge: string | null;
  onDismiss: () => void;
}) {
  const linked = outcome.kind === 'linked';
  const Icon = linked ? CircleCheckIcon : CircleAlertIcon;
  return (
    <div
      role={linked ? 'status' : 'alert'}
      className="border-border flex items-start gap-2 rounded-md border px-3 py-2"
    >
      <Icon
        aria-hidden="true"
        strokeWidth={1.5}
        className={`mt-0.5 size-4 shrink-0 ${linked ? 'text-state-success' : 'text-state-danger'}`}
      />
      <p className="text-foreground min-w-0 flex-1 text-sm">
        {outcomeWords(outcome, forge)}
      </p>
      <Button
        variant="ghost"
        size="sm"
        className="-my-1 shrink-0"
        onClick={onDismiss}
      >
        {SIGN_IN_COPY.dismiss}
      </Button>
    </div>
  );
}
